import React from 'react';
import { ButtonGroup, Button } from "react-bootstrap";
import useFontSize from "../providers/use_font_settings";

const FontsizeOptions = () => {
  const { setFontSize } = useFontSize();

  return <div style={{ textAlign: "right" }}>
  <ButtonGroup size="sm" aria-label="opciones de tamaño">
    <Button onClick={() => setFontSize(-5)} variant="secondary">
      <i style={{ fontSize: "70%" }} className="fas fa-font"></i>-
    </Button>
    <Button onClick={() => setFontSize(5)} variant="secondary">
      <i style={{ fontSize: "100%" }} className="fas fa-font"></i>+
    </Button>
  </ButtonGroup>
</div>
}

export default FontsizeOptions